module.exports = __webpack_public_path__ + "media/images/lb/655-04fbf436922310a33cf1bd05a0587cc1.svg";